import { LOCALES } from 'modules/translation';

export const SPARKLE_SUPPORTED_LOCALES = [LOCALES.PT, LOCALES.EN, LOCALES.ES];
